/**
 * @generated SignedSource<<c606d7a22d32d6a3fbda849c0cec34c8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type HasForm = "HAS_FORM" | "NO_FORM" | "%future added value";
export type QueryMatch = "EQUAL_MATCH" | "INCLUDING_MATCH" | "PREFIX_MATCH" | "%future added value";
export type UrlMatch = "EQUAL_TYPE" | "HAS_ID_TYPE" | "EQUAL_OR_HAS_ID_TYPE" | "STARTS_WITH_PREFIX_MATCH" | "REGEX_MATCH_TYPE" | "%future added value";
export type CreateFunnelInput = {
  clientMutationId?: string | null;
  name: string;
  isExperiment: boolean;
  siteId: string;
  landingPageAttributes: PageAttributes;
  formPageAttributes?: ReadonlyArray<PageAttributes> | null;
  confirmPageAttributes?: PageAttributes | null;
  thanksPageAttributes: PageAttributes;
};
export type PageAttributes = {
  id?: string | null;
  name: string;
  url: string;
  mobileUrl?: string | null;
  tabletUrl?: string | null;
  hasForm?: HasForm | null;
  urlMatchType: UrlMatch;
  queryMatchType?: QueryMatch | null;
  isEnableWhiteout?: boolean | null;
  isSpa?: boolean | null;
  pageUrlRegex?: string | null;
};
export type FunnelCreateFormContainer_Mutation$variables = {
  input: CreateFunnelInput;
  connections: ReadonlyArray<string>;
};
export type FunnelCreateFormContainer_MutationVariables = FunnelCreateFormContainer_Mutation$variables;
export type FunnelCreateFormContainer_Mutation$data = {
  readonly createFunnel: {
    readonly funnelEdge: {
      readonly node: {
        readonly id: string;
        readonly slug: string;
        readonly name: string;
        readonly isExperiment: boolean;
        readonly landingPage: {
          readonly name: string;
          readonly url: string;
          readonly mobileUrl: string | null;
          readonly tabletUrl: string | null;
          readonly hasForm: HasForm | null;
          readonly urlMatchType: UrlMatch;
          readonly queryMatchType: QueryMatch;
          readonly isEnableWhiteout: boolean;
          readonly isSpa: boolean;
          readonly pageUrlRegex: string | null;
        } | null;
        readonly thanksPage: {
          readonly name: string;
          readonly url: string;
          readonly mobileUrl: string | null;
          readonly tabletUrl: string | null;
          readonly urlMatchType: UrlMatch;
          readonly queryMatchType: QueryMatch;
          readonly isEnableWhiteout: boolean;
          readonly isSpa: boolean;
          readonly pageUrlRegex: string | null;
        } | null;
        readonly confirmPage: {
          readonly name: string;
          readonly url: string;
          readonly mobileUrl: string | null;
          readonly tabletUrl: string | null;
          readonly urlMatchType: UrlMatch;
          readonly queryMatchType: QueryMatch;
          readonly isEnableWhiteout: boolean;
          readonly isSpa: boolean;
          readonly pageUrlRegex: string | null;
        } | null;
        readonly formPage: ReadonlyArray<{
          readonly name: string;
          readonly url: string;
          readonly mobileUrl: string | null;
          readonly tabletUrl: string | null;
          readonly urlMatchType: UrlMatch;
          readonly queryMatchType: QueryMatch;
          readonly isEnableWhiteout: boolean;
          readonly isSpa: boolean;
          readonly pageUrlRegex: string | null;
        }> | null;
      } | null;
    } | null;
  } | null;
};
export type FunnelCreateFormContainer_MutationResponse = FunnelCreateFormContainer_Mutation$data;
export type FunnelCreateFormContainer_Mutation = {
  variables: FunnelCreateFormContainer_MutationVariables;
  response: FunnelCreateFormContainer_Mutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isExperiment",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mobileUrl",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tabletUrl",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasForm",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlMatchType",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "queryMatchType",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isEnableWhiteout",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSpa",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pageUrlRegex",
  "storageKey": null
},
v16 = [
  (v5/*: any*/),
  (v7/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/)
],
v17 = [
  (v5/*: any*/),
  (v7/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/),
  (v3/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "FunnelCreateFormContainer_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "CreateFunnelPayload",
        "kind": "LinkedField",
        "name": "createFunnel",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FunnelEdge",
            "kind": "LinkedField",
            "name": "funnelEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Funnel",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Page",
                    "kind": "LinkedField",
                    "name": "landingPage",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Page",
                    "kind": "LinkedField",
                    "name": "thanksPage",
                    "plural": false,
                    "selections": (v16/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Page",
                    "kind": "LinkedField",
                    "name": "confirmPage",
                    "plural": false,
                    "selections": (v16/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Page",
                    "kind": "LinkedField",
                    "name": "formPage",
                    "plural": true,
                    "selections": (v16/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "FunnelCreateFormContainer_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "CreateFunnelPayload",
        "kind": "LinkedField",
        "name": "createFunnel",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FunnelEdge",
            "kind": "LinkedField",
            "name": "funnelEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Funnel",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Page",
                    "kind": "LinkedField",
                    "name": "landingPage",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Page",
                    "kind": "LinkedField",
                    "name": "thanksPage",
                    "plural": false,
                    "selections": (v17/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Page",
                    "kind": "LinkedField",
                    "name": "confirmPage",
                    "plural": false,
                    "selections": (v17/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Page",
                    "kind": "LinkedField",
                    "name": "formPage",
                    "plural": true,
                    "selections": (v17/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendEdge",
            "key": "",
            "kind": "LinkedHandle",
            "name": "funnelEdge",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "207767964ff5f3d118442d4be23118ea",
    "id": null,
    "metadata": {},
    "name": "FunnelCreateFormContainer_Mutation",
    "operationKind": "mutation",
    "text": "mutation FunnelCreateFormContainer_Mutation(\n  $input: CreateFunnelInput!\n) {\n  createFunnel(input: $input) {\n    funnelEdge {\n      node {\n        id\n        slug\n        name\n        isExperiment\n        landingPage {\n          name\n          url\n          mobileUrl\n          tabletUrl\n          hasForm\n          urlMatchType\n          queryMatchType\n          isEnableWhiteout\n          isSpa\n          pageUrlRegex\n          id\n        }\n        thanksPage {\n          name\n          url\n          mobileUrl\n          tabletUrl\n          urlMatchType\n          queryMatchType\n          isEnableWhiteout\n          isSpa\n          pageUrlRegex\n          id\n        }\n        confirmPage {\n          name\n          url\n          mobileUrl\n          tabletUrl\n          urlMatchType\n          queryMatchType\n          isEnableWhiteout\n          isSpa\n          pageUrlRegex\n          id\n        }\n        formPage {\n          name\n          url\n          mobileUrl\n          tabletUrl\n          urlMatchType\n          queryMatchType\n          isEnableWhiteout\n          isSpa\n          pageUrlRegex\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c26c8a1c10970633d782e98bb45648b7";

export default node;
